import { render, staticRenderFns } from "./course_study.vue?vue&type=template&id=8a0f3070&scoped=true"
import script from "./course_study.vue?vue&type=script&lang=js"
export * from "./course_study.vue?vue&type=script&lang=js"
import style0 from "./course_study.vue?vue&type=style&index=0&id=8a0f3070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0f3070",
  null
  
)

export default component.exports